// extracted by mini-css-extract-plugin
module.exports = {"NavLinksContainer":"Navigation_NavLinksContainer__1V55s","NavLink":"Navigation_NavLink__bcpT3","activeNavLink":"Navigation_activeNavLink__2SAwL"};